<template>
  <div
    class="px-3 py-1 rounded-lg"
    :class="itemDetails.isDraggable ? 'sub_heading darken-1' : 'white'"
  >
    <v-expansion-panel-header
      expand-icon=""
      class="pa-0 ma-0 app-list-card-expansion-header"
    >
      <div
        class="d-flex algin-center justify-center justify-space-between py-1 px-0 app-relative"
      >
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <span
              class="text-caption font-weight-bold d-flex align-center"
              v-bind="attrs"
              v-on="on"
            >
              <div style="width:30px">
                <v-checkbox
                  v-if="!itemDetails.isDraggable"
                  v-model="itemDetails.isChecked"
                  hide-details="auto"
                  class="pa-0 ma-0"
                  color="success"
                ></v-checkbox>
              </div>

              <span class="pr-1">
                <ItemType :type="itemDetails.storage_type"></ItemType>
              </span>

              {{ itemDetails.item_no }}
            </span>
          </template>
          <span class="text-capitalize">Item number</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
              <v-chip
                small
                class="px-2"
                label
                color="primary"
                v-if="itemDetails.sales_quantity != 0"
              >
                <span class="text-caption white--text">
                  Qty {{ itemDetails.sales_quantity }}
                </span>
              </v-chip>
            </div>
          </template>
          <span class="text-capitalize">Quantity</span>
        </v-tooltip>
      </div>
    </v-expansion-panel-header>
    <v-expansion-panel-content class="px-0 py-2" v-if="itemDetails">
      <v-row no-gutters @click="$emit('selectedItem', itemDetails)">
        <v-col cols="5">
          <OrderTooltipWithIcon
            v-if="itemDetails.item_original_volume"
            icon="mdi-package-variant-closed"
            :text="`
              ${(
                itemDetails.item_original_volume * itemDetails.sales_quantity
              ).toFixed(4)} CBM
            `"
            :label="`volume`"
          />
        </v-col>
        <v-col cols="6">
          <OrderTooltipWithIcon
            v-if="itemDetails.item_original_weight"
            icon="mdi-weight"
            :text="`
              ${(
                itemDetails.item_original_weight * itemDetails.sales_quantity
              ).toFixed(2)} Kg
            `"
            :label="`weight`"
          />
        </v-col>
      </v-row>
    </v-expansion-panel-content>
  </div>
</template>

<script>
import OrderTooltipWithIcon from "@/components/ModuleBasedComponents/Order/OrderTooltipWithIcon.vue";
import { orderStatus } from "@/utils/fieldConstants";
import {
  customerModule,
  orderModule,
  statusMapping,
  itemModule,
} from "@/utils/moduleMapping";
import ItemType from "@/components/AgIcon/ItemType.vue";
export default {
  components: {
    OrderTooltipWithIcon,
    ItemType,
  },
  props: {
    itemDetails: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      itemModule,
      orderStatus,
      statusMapping,
      customerModule,
      orderModule,
    };
  },
  computed: {
    userDetails() {
      let obj = this.$helper.getUserDetailsLocalStorage();
      if (obj) {
        return obj;
      }
    },
  },
};
</script>
